import { combineReducers } from '@reduxjs/toolkit';
import comprovantes from './slices/comprovantes.slice';

const reducer = combineReducers({
	comprovantes
});

export default reducer;
